<div class="approval-modal-overlay">
  <div class="approval-modal">
    <div class="modal-header">
      <div>
        <h2>Can't find your college/university?</h2>
        <p>Submit it below — it will be added to search once an admin approves it.</p>
      </div>

      <button class="close-btn" type="button" (click)="closeDialogBox()" [disabled]="isSubmitting" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <form [formGroup]="collegeForm" (ngSubmit)="submit()">
      <div class="modal-body">
        <div class="field-row">
          <div class="field">
            <label class="modal-label">First Name</label>
            <input class="modal-input" type="text" [value]="data.firstName" readonly disabled />
          </div>
          <div class="field">
            <label class="modal-label">Last Name</label>
            <input class="modal-input" type="text" [value]="data.lastName || ''" readonly disabled />
          </div>
        </div>

        <div class="field">
          <label class="modal-label">Email</label>
          <input class="modal-input" type="text" [value]="data.email" readonly disabled />
        </div>

        <div class="field">
          <label class="modal-label">College / University Name <span class="required">*</span></label>
          <input
            class="modal-input"
            type="text"
            formControlName="name"
            placeholder="Enter college/university name"
            maxlength="100"
          />
          <small class="field-error" *ngIf="collegeForm.get('name')?.invalid && collegeForm.get('name')?.touched">
            <span *ngIf="collegeForm.get('name')?.errors?.['required']">College/University name is required</span>
            <span *ngIf="collegeForm.get('name')?.errors?.['minlength']">Must be at least 2 characters</span>
            <span *ngIf="collegeForm.get('name')?.errors?.['maxlength']">Must be at most 100 characters</span>
          </small>
        </div>

        <div class="field">
          <label class="modal-label">Abbreviation <span class="optional">(optional)</span></label>
          <input
            class="modal-input"
            type="text"
            formControlName="abbreviation"
            placeholder="e.g. MIT"
            maxlength="50"
          />
          <small class="field-error" *ngIf="collegeForm.get('abbreviation')?.invalid && collegeForm.get('abbreviation')?.touched">
            <span *ngIf="collegeForm.get('abbreviation')?.errors?.['maxlength']">Must be at most 50 characters</span>
          </small>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="modal-label">City <span class="required">*</span></label>
            <input class="modal-input" type="text" formControlName="city" placeholder="City" maxlength="100" />
            <small class="field-error" *ngIf="collegeForm.get('city')?.invalid && collegeForm.get('city')?.touched">
              <span *ngIf="collegeForm.get('city')?.errors?.['required']">City is required</span>
              <span *ngIf="collegeForm.get('city')?.errors?.['maxlength']">Must be at most 100 characters</span>
            </small>
          </div>

          <div class="field">
            <label class="modal-label">State <span class="required">*</span></label>
            <input class="modal-input" type="text" formControlName="state" placeholder="State" maxlength="100" />
            <small class="field-error" *ngIf="collegeForm.get('state')?.invalid && collegeForm.get('state')?.touched">
              <span *ngIf="collegeForm.get('state')?.errors?.['required']">State is required</span>
              <span *ngIf="collegeForm.get('state')?.errors?.['maxlength']">Must be at most 100 characters</span>
            </small>
          </div>
        </div>

        <div class="field">
          <label class="modal-label">Country</label>
          <input class="modal-input" type="text" formControlName="country" readonly />
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" type="button" (click)="closeDialogBox()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button class="send-btn" type="submit" [disabled]="collegeForm.invalid || isSubmitting">
          <span *ngIf="!isSubmitting">Submit</span>
          <span *ngIf="isSubmitting">Submitting…</span>
        </button>
      </div>
    </form>
  </div>
</div>
